"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentFloatingInputPage_1 = require("./ComponentFloatingInputPage");
exports.ComponentFloatingInputPage = ComponentFloatingInputPage_1.ComponentFloatingInputPage;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFloatingInputPage/index.ts
// module id = 672
// module chunks = 0